import { render, staticRenderFns } from "./messages-popwindow-detail.vue?vue&type=template&id=56a8fb72"
import script from "./messages-popwindow-detail.vue?vue&type=script&lang=js"
export * from "./messages-popwindow-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports